import React from 'react';
import { Card as Bs5Thumbnail } from 'react-bootstrap5';

const Thumbnail = props => {
  const { handleClick, imgSrc, title, description } = props;

  return (
    <Bs5Thumbnail {...props} onClick={handleClick}>
      <Bs5Thumbnail.Img variant="top" src={imgSrc} alt="" />
      <Bs5Thumbnail.Body>
        <Bs5Thumbnail.Title>{title}</Bs5Thumbnail.Title>
        <Bs5Thumbnail.Text>{description}</Bs5Thumbnail.Text>
      </Bs5Thumbnail.Body>
    </Bs5Thumbnail>
  );
};

export default Thumbnail;
